<script>
export default {
  name: 'PageIndicator',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
<div class="indicator" :class="{active: active}">
</div>
</template>

<style scoped>
.indicator {
  border-radius: 50%;
  height: 8px;
  width: 8px;
  border-color: #B40055;
  background: white;
}

.active {
  width: 12px !important;
  height: 12px !important;
  background: #B40055;
}
</style>